/* tslint:disable */
/* eslint-disable */
/**
 * external-information-requests
 * Medicaid Pending document requests to family members, with the staff workspace and the family portal
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StaffUserRef
 */
export interface StaffUserRef {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    display_name: string;
}

/**
 * Check if a given object implements the StaffUserRef interface.
 */
export function instanceOfStaffUserRef(value: object): value is StaffUserRef {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('display_name' in value) || value['display_name'] === undefined) return false;
    return true;
}

export function StaffUserRefFromJSON(json: any): StaffUserRef {
    return StaffUserRefFromJSONTyped(json, false);
}

export function StaffUserRefFromJSONTyped(json: any, ignoreDiscriminator: boolean): StaffUserRef {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'display_name': json['display_name'],
    };
}

export function StaffUserRefToJSON(json: any): StaffUserRef {
    return StaffUserRefToJSONTyped(json, false);
}

export function StaffUserRefToJSONTyped(value?: StaffUserRef | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'display_name': value['display_name'],
    };
}

